var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property_price, property_tax, leadSubmitted, isLeadFormSuppressed, sec_summary, propertyStatus, pageType, ctaText, ctaButtonName, hasSuppressLeadForm } = options; 
__p+='\n';
 if(ctaText == 'V1') { 
__p+='\n  ';
 ctaButtonName = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n<div class="qv-property-history">\n  <div class="panel">\n    <div class="accordion-heading collapsed" role="tab" data-toggle="collapse" href="#collapse-property-history" aria-expanded="false" aria-controls="collapse-property-history" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-history:expand">\n      <h2 class="title-section accordion-title">\n        <i class="ra ra-property-history"></i>Property History\n      </h2>\n      <p class="sec-summary ellipsis">\n        '+
((__t=( sec_summary ))==null?'':__t)+
'\n      </p>\n    </div>\n    <div id="collapse-property-history" class="panel-collapse collapse" role="tabpanel" aria-labelledby="collapsePropertyHistory">\n      <div class="panel-body">\n          <div class="subsection">\n            <h3 class="header-subsection">Property Price</h3>\n            ';
 if(property_price && property_price.length) { 
__p+='\n              <div class="';
 if (property_price.length > 6) { 
__p+='load-more-features';
 } 
__p+='">\n                <table class="table table-clear table-heading-unstyled">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Event</th>\n                      <th class="text-align-center">Price</th>\n                      <th class="text-align-center hidden-qv-xs">Price/Sq Ft</th>\n                      <th class="hidden-qv-xs">Source</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    ';
 property_price.forEach((price_history) => { 
__p+='\n                      <tr>\n                        <td>'+
((__t=( price_history.date_display ))==null?'':__t)+
'</td>\n                        <td>'+
((__t=( price_history.event_name ))==null?'':__t)+
'</td>\n                        <td class="text-align-center">'+
((__t=( price_history.price_display ))==null?'':__t)+
'</td>\n                        <td class="text-align-center hidden-qv-xs">'+
((__t=( price_history.price_sqft_display ))==null?'':__t)+
'</td>\n                        <td class="hidden-qv-xs">'+
((__t=( price_history.datasource_name_display ))==null?'':__t)+
'</td>\n                      </tr>\n                    ';
 }) 
__p+='\n                  </tbody>\n                </table>\n              </div>\n            ';
 } else { 
__p+='\n                <p>No price history available for this property.</p>\n            ';
 } 
__p+='\n          </div>\n          <div class="subsection">\n            <h3 class="header-subsection">Property Tax</h3>\n            ';
 if(property_tax && property_tax.length) { 
__p+='\n              <div class="';
 if (property_tax.length > 6) { 
__p+='load-more-features';
 } 
__p+='">\n                <table class="table table-clear table-heading-unstyled">\n                <thead>\n                  <tr>\n                    <th>Year</th>\n                    <th class="text-align-center">Taxes</th>\n                    <th class="text-align-center hidden-qv-xs">Land</th>\n                    <th class="hidden-qv-xs"></th>\n                    <th class="text-align-center hidden-qv-xs">Additions</th>\n                    <th class="hidden-qv-xs"></th>\n                    <th class="text-align-center">Total Assessment</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  ';
 property_tax.forEach((tax_history) => { 
__p+='\n                    <tr>\n                      <td>'+
((__t=( tax_history.year_display ))==null?'':__t)+
'</td>\n                      <td class="text-align-center">'+
((__t=( tax_history.tax_display ))==null?'':__t)+
'</td>\n                      <td class="text-align-center hidden-qv-xs">'+
((__t=( tax_history.land_assessment_display ))==null?'':__t)+
'</td>\n                      <td class="hidden-qv-xs">+</td>\n                      <td class="text-align-center hidden-qv-xs">'+
((__t=( tax_history.building_assessment_display ))==null?'':__t)+
'</td>\n                      <td class="hidden-qv-xs">=</td>\n                      <td class="text-align-center">'+
((__t=( tax_history.total_assessment_display ))==null?'':__t)+
'</td>\n                    </tr>\n                  ';
 }) 
__p+='\n                </tbody>\n              </table>\n            </div>\n            ';
 } else { 
__p+='\n              <p>No property tax history available for this property. </p>\n            ';
 } 
__p+='\n          </div>\n          <div class="clearfix">\n            <h5 class="font-size-small">About History &amp; Taxes Data </h5>\n            <p class="font-size-small">\n              The price and tax history data displayed is obtained from public records and/or MLS feeds from the local jurisdiction.\n              Contact your REALTOR<sup>®</sup> directly in order to obtain the most up-to-date information available.\n            </p>\n          </div>\n          ';
 if (!leadSubmitted && !isLeadFormSuppressed && hasSuppressLeadForm) { 
__p+='\n            <div class="margin-top-lg text-center">\n              <span class="font-bold">Want to get comps?</span>\n              <a href="javascript:void(0)" data-title="Want to get Comps?" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-history:contact_agent" data-placeholder="I would like to know more about comps in this area." data-formid="secondary">\n               <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n              '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n              </span></div>\n              </a>\n            </div>\n          ';
 } 
__p+='\n      </div>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-property-history.jst.ejs